/**
 * Normalizes the `settings` array from the API into a key-value object.
 *
 * The API delivers a flat array with key-value pairs, e.g.:
 * `["variant", "info", "class", "alarm-modal", "id", "clock-out"]`
 *
 * This function converts it into:
 * `{ variant: "info", class: "alarm-modal", id: "clock-out" }`
 *
 * If the input is not an array, an empty object is returned.
 *
 * @param {any[] | undefined} settings - Flat array of alternating keys and values.
 * @returns {Record<string, any>} An object mapping keys to values.
 */
export function normalizeSettings(settings?: any[]): Record<string, any> {
    if (!Array.isArray(settings)) return {};
    const obj: Record<string, any> = {};

    for (let i = 0; i < settings.length; i += 2) {
        const key = settings[i] as string;
        obj[key] = settings[i + 1];
    }

    return obj;
}
